import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"

export const BoxProgrammingHeaderLeftView: React.FC = () => {
  return (
    <div
      className="flex flex-column rounded-33 bg-neutralColor-50 gap-2 p-1 md:p-2 xl:p-4 mb-5"
      style={{ height: "200px" }}
    >
      <HUText fontStyle="TM">{word("box.programmation.activity.typicalWeek")}</HUText>
      <HUText fontStyle="BS">{word("box.programmation.typicalWeek.subTitle")}</HUText>
    </div>
  )
}
